import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import TagManager from 'react-gtm-module';
import * as serviceWorker from './serviceWorker';
import 'materialize-css';
import 'materialize-css/dist/css/materialize.min.css';
import './web/resource/css/index.css';
import './web/resource/css/header.css';
import './web/resource/css/fonts.css';
import '../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
// console.log(process.env.REACT_APP_AMBIENTE);
// const tagManagerArgs = {
//     gtmId: process.env.REACT_APP_GTM
// }
// TagManager.initialize(tagManagerArgs);

ReactDOM.render(<App/>, document.getElementById('root'));
serviceWorker.unregister();
